import type { ApiRoute, NoQueryParams } from "../../../api"
import type { PricingChange, PricingView } from "../../../inventoryInformation"

export interface UpdatePricingPathParams {
	inventoryId: string
}

export const updatePricingRoute: ApiRoute<UpdatePricingPathParams, NoQueryParams, PricingChange, PricingView> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/pricing`,
	method: "patch",
	path: "/vehicles/:inventoryId/pricing",
}
